import React from 'react';
import Reveal from './Reveal';
import SplitText from './SplitText';

export default function SectionHead({ index, label, title, aside }) {
  return (
    <div className="section-head">
      <Reveal className="section-head__meta" y={12}>
        <span className="index">{index}</span>
        <span className="label">{label}</span>
      </Reveal>
      <div>
        <SplitText as="h2" className="h2" text={title} inView stagger={0.035} duration={0.8} />
        {aside ? (
          <Reveal className="section-head__aside" delay={0.2} y={12}>
            {aside}
          </Reveal>
        ) : null}
      </div>
    </div>
  );
}
